import { render } from "./DetailMutantModal.vue?vue&type=template&id=7af43465&scoped=true"
import script from "./DetailMutantModal.vue?vue&type=script&lang=js"
export * from "./DetailMutantModal.vue?vue&type=script&lang=js"

import "./DetailMutantModal.vue?vue&type=style&index=0&id=7af43465&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af43465"]])

export default __exports__